import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useActivityHistory } from "PFCore/hooks/queries/activities/history";

import { useActivityHistoryContext } from "../context";

export const ACTIVITY_UPDATED_EVENT_TYPE = "activity_updated";
export const ACTIVITY_CONNECTIONS_UPDATED_EVENT_TYPE = "activity_connections_updated";

export const useHistoryTabEvents = () => {
  const activity = useCurrentActivity();
  const { page, sortBy, filters } = useActivityHistoryContext();

  // Product decision to merge `activity_connections_updated` with `activity_updated`
  const eventType = filters.eventType.includes(ACTIVITY_UPDATED_EVENT_TYPE)
    ? [...filters.eventType, ACTIVITY_CONNECTIONS_UPDATED_EVENT_TYPE]
    : filters.eventType;

  return useActivityHistory(activity?.id || "", {
    page,
    sortBy,
    ...filters,
    eventType
  });
};
